module.exports = __webpack_public_path__ + "static/LucasPope7-2087188108801eaf03ab969a8595493d.webp";